let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("5tz7G"), load("87Teh")]).then(() => parcelRequire('hoY46'));